/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ permissions: NonNullable<unknown> }} Common_Errors_Missingpermissions1Inputs */

const en_common_errors_missingpermissions1 = /** @type {(inputs: Common_Errors_Missingpermissions1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You do not have the required permissions (${i?.permissions}) to view this page`)
};

/**
* | output |
* | --- |
* | "You do not have the required permissions ({permissions}) to view this page" |
*
* @param {Common_Errors_Missingpermissions1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_errors_missingpermissions1 = /** @type {((inputs: Common_Errors_Missingpermissions1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Errors_Missingpermissions1Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_errors_missingpermissions1(inputs)
});
export { common_errors_missingpermissions1 as "common_errors_missingPermissions" }